<template>
  <div class="right-home product-list">
    <div class="breadcrumb">售后问题维护</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px">
        <el-row>
          <el-col :span="5.5">
            <el-form-item label="关键词:">
              <el-input v-model="formInline.postsaleNo" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn" style="margin-top:0;">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button type="primary" @click="isEdit = false, addDialog = true" round>新建问题类型</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="问题类型" prop="value"></el-table-column>
          <el-table-column label="是否启用">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.enabled" @change="changeActive(scope.row, $event)" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" style="margin-right:10px;" @click="edit(scope.row)">编辑</span>
              <span class="color-blue">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <!-- <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination> -->
    </div>
    <el-dialog :close-on-click-modal="false" :title="isEdit ? '编辑' : '新建问题类型'" :visible.sync="addDialog" width="400px">
      <span style="margin:0 10px 0 20px">问题类型:</span>
      <el-input v-model="addForm.value" style="width:200px;" clearable></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button @click="save()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 确认删除 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
// import VPagination from '@/components/Pagination/index.vue'
import { postsaleTypeList, postsaleType, postsaleTypeChangeEnabled, postsaleTypeEdit } from '@/api/oms.js'
export default {
  components: {
    // VPagination
  },
  data () {
    return {
      isEdit: false,
      editItem: {},
      addDialog: false,
      addForm: {
        enabled: true,
        sort: 0,
        value: ''
      },
      deleteDialog: false,
      formInline: {
        auditStatus: '',
        dateEnd: '',
        dateStart: '',
        orderNo: '',
        phone: '',
        postsaleNo: ''
      },
      tableData: [],
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    edit (row) {
      this.isEdit = true
      this.editItem = row
      this.addForm.value = row.value
      this.addDialog = true
    },
    changeActive (row, val) {
      postsaleTypeChangeEnabled({
        postsaleTypeId: row.id,
        enabled: val
      })
        .then(res => {
          if (res.data.success) {
            this.$message.success('修改成功')
          }
        })
    },
    save () {
      if (this.isEdit) {
        postsaleTypeEdit({
          postsaleTypeId: this.editItem.id,
          data: { value: this.addForm.value }
        })
          .then(res => {
            if (res.data.success) {
              this.onSubmit()
              this.addDialog = false
            }
          })
      } else {
        postsaleType(this.addForm)
          .then(res => {
            if (res.data.success) {
              this.$message.success('添加成功')
              this.addDialog = false
            }
          })
      }
    },
    onSubmit () {
      postsaleTypeList({ enabled: true })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data
          }
        })
    },
    changePage (val) {
      this.queryInfo = val
      this.getProList(this.queryInfo)
    }
  }
}
</script>
 <style scoped lang="less">
 @deep: ~">>>";
 </style>
